import React from 'react';
import { FilterableProductListLoader } from '../../../../components';

export const InnerEnhancedFilterableProductListLoader: React.FC = () => {
    return <FilterableProductListLoader />;
};
